export const Colors = {
	black: "#333333",
	action: "#F85489",
	flowyText:
		"linear-gradient(81.2deg, #661AFF 13.15%, #7E1AFF 25.39%, #FF5781 72.82%, #FF977B 86.59%)",
	flowy:
		"linear-gradient(34.18deg, #661AFF 0%, #7E1AFF 16.67%, #FF7093 81.25%, #FFAB95 100%); background: linear-gradient(34.18deg, color(display-p3 0.4 0.1 1) 0%, color(display-p3 0.49 0.1 1) 16.67%, color(display-p3 1 0.43 0.57) 81.25%, color(display-p3 1 0.67 0.58) 100%)",
	flowUp:
		"linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0.8) 47.4%, rgba(255, 255, 255, 0) 100%), linear-gradient(58.22deg, #521AFF 0%, #7E1AFF 16.31%, #DF738E 79.5%, #F9BAA9 97.85%)",
}
